import PropTypes from 'prop-types';
import React, {Component} from 'react';

class Button extends Component {

    static propTypes = {
        label: PropTypes.string,
        boldFont: PropTypes.bool,
        onClick: PropTypes.func
    }

    handleKeyDown = (event) => {
        if (event.key === ' ' || event.key === 'Enter') {
            event.preventDefault(); // prevent page from scrolling
            if (this.props.onClick) {
                this.props.onClick(event);
            }
        }
    };

    render() {
        return (
            <a tabIndex={0}
               role={'button'}
               className={`button ${this.props.boldFont ? 'button--bold' : ''}`}
               onClick={this.props.onClick}
               onKeyDown={this.handleKeyDown}
               {...this.props}
            >
                {this.props.label}
            </a>
        )
    }
}

export default Button



/** WEBPACK FOOTER **
 ** ./src/components/navigation/Button.js
 **/